import { BaseError } from '~/lib/error/base';

export class ConfirmPasswordFailedError extends BaseError {
  constructor(message: string) {
    super({ code: 'CONFIRM_PASSWORD_FAILED', message });
  }
}
